// export const baseurlvmkp='https://vmkgserver.in:8443/vmkp/api'

export const baseurlvmkp='https://vmkgserver.in:8443/vmkp/api'
export const baseexcel='https://vmkgserver.in:8443/vmkp/'
export const loadingcherker = (value) => {
    return value ? value : false;
  };
